<div class="panel panel-form" [ngClass]="{ open: open }">
  <lib-form-header
    [open]="open"
    [header]="'dates'"
    [required]="required"
    (openChange)="open = $event"
  ></lib-form-header>
  @if (open && form) {
    <div class="panel-content">
      <form [formGroup]="form">
        <div class="row">
          <div class="col-6 col-md-6 form-field-container">
            <div class="form-field-label">
              {{ 'form.field.available_from' | transloco }}
            </div>
            <lib-date-time-field formControlName="start">
              @if (getFormControl('start').invalid) {
                <mat-error>
                  @if (getFormControl('start').errors.required) {
                    {{ 'form.error.required' | transloco }}
                  }
                  @if (getFormControl('start').errors.datesRange) {
                    {{ 'form.error.date_range' | transloco }}
                  }
                </mat-error>
              }
            </lib-date-time-field>
          </div>
          <div class="col-6 col-md-6 form-field-container">
            <div class="form-field-label">
              {{ 'form.field.available_to' | transloco }}
            </div>
            <lib-date-time-field formControlName="finish">
              @if (getFormControl('finish').invalid) {
                <mat-error>
                  @if (getFormControl('finish').errors.required) {
                    {{ 'form.error.required' | transloco }}
                  }
                  @if (getFormControl('finish').errors.datesRange) {
                    {{ 'form.error.date_range' | transloco }}
                  }
                </mat-error>
              }
            </lib-date-time-field>
          </div>
        </div>
      </form>
    </div>
  }
</div>
